/* eslint-disable react/prop-types */
import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#3778C2';

const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
		alignItems: 'stretch', // makes all cells equal height
		minHeight: 40,
	},

	cell: {
		fontSize: 8,
		padding: 5,
		borderRightWidth: 1,
		borderRightColor: borderColor,
		justifyContent: 'center',
		display: 'flex',
	},

	id: {
		width: '6%',
		textAlign: 'center',
		borderLeftWidth: 1,
		borderLeftColor: borderColor,
	},

	name: {
		width: '14%',
		textAlign: 'left',
	},

	user: {
		width: '14%',
		textAlign: 'left',
	},

	assignedDate: {
		width: '12%',
		textAlign: 'center',
	},

	endDate: {
		width: '12%',
		textAlign: 'center',
	},

	description: {
		width: '18%',
		textAlign: 'left',
	},

	remarks: {
		width: '14%',
		textAlign: 'left',
	},

	status: {
		width: '10%',
		textAlign: 'center',
	},

	endborder: {
		borderBottomColor: borderColor,
		borderBottomWidth: 1,
		width: '100%',
	},
});

const InvoiceTableRow = (props) => {
	const rows = props.data?.map((item, index) => (
		<View key={index} wrap={false}>
			<View style={styles.row}>
				<Text style={[styles.cell, styles.id]}>
					{item?.id ?? ''}
				</Text>

				<Text style={[styles.cell, styles.name]}>
					{item?.name ?? ''}
				</Text>

				<Text style={[styles.cell, styles.user]}>
					{item?.user ?? ''}
				</Text>

				<Text style={[styles.cell, styles.assignedDate]}>
					{item?.assignedDate ?? ''}
				</Text>

				<Text style={[styles.cell, styles.endDate]}>
					{item?.endDate ?? ''}
				</Text>

				<Text style={[styles.cell, styles.description]}>
					{item?.description ?? ''}
				</Text>

				<Text style={[styles.cell, styles.remarks]}>
					{item?.remarks ?? ''}
				</Text>

				<Text style={[styles.cell, styles.status]}>
					{item?.status ?? ''}
				</Text>
			</View>

			<View style={styles.endborder} />
		</View>
	));

	return <>{rows}</>;
};

export default InvoiceTableRow;